import React, { useEffect, useState } from "react";
import { Button } from "antd";
import SisLoader from "../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import AddBoilerModal from "../components/AddBoilerModal";
import BoilerTable from "../components/BoilerRow";

function Boiler({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [FilteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responeData, setResponeData] = useState({});
  const [errors, set_errors] = useState({});

  const LIST_API = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", id);
    try {
      post(ApiURL.list_boiler_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.response_data);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const ADD_API = (data) => {
    set_loader(true);

    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("title", data?.title);
      FORM_DATA.append("boiler_model", data?.model);
      FORM_DATA.append("boiler_make", data?.make);
      FORM_DATA.append("boiler_capacity", data?.capacity);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      post(ApiURL.add_boiler_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Boiler Details Saved!", "Boiler Details Successfully Added!!");
          LIST_API();
          setIsModalOpen(false);
          set_loader(false);
          if (onSuccess) onSuccess();
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      set_loader(false);
      console.error("Error occurred while adding boiler details:", error);
    }
  };

  const UPDATE_API = (data) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("title", data?.title);
      FORM_DATA.append("boiler_model", data?.model);
      FORM_DATA.append("boiler_make", data?.make);
      FORM_DATA.append("boiler_capacity", data?.capacity);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "add-edit");
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      post(ApiURL.ship_boiler_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("success", res?.message);
          LIST_API();
          setIsModalOpen(false);
          set_loader(false);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = (data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.ship_boiler_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setResponeData(res?.boiler_data);
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } finally {
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Boiler Information </h3>
        <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add Boiler
        </Button>
        <AddBoilerModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responeData?.id) {
              UPDATE_API({ ...data, id: responeData.id });
            } else {
              ADD_API(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponeData({});
            set_errors({});
          }}
          responeData={responeData}
          errors={errors}
        />

        {loader ? (
          <SisLoader />
        ) : (
          <>
            {FilteredData?.length > 0 ? (
              <BoilerTable data={FilteredData} onEdit={(row) => VIEW_API(row)} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Boiler;
